export default {
  title: 'yellow',

  twitter: '#ffad1f',
  twitter_dark_hover: 'rgba(255, 173, 31, .1)',
  twitter_light_hover: '#e69c1c',
}